import { TrashIcon } from '@heroicons/react/24/outline';
import { Button } from '@nextui-org/react';
import React from 'react';

import { ModernModal } from '@portal/components/common/ModernModal.ui';
import { TypographyUI } from '@portal/components/common/Typography.ui';

interface DeleteUserModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
  selectedUser: {
    id: number;
    username: string;
  } | null;
  onSubmit: () => void;
  isLoading?: boolean;
}

export const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  isOpen,
  onOpenChange,
  selectedUser,
  onSubmit,
  isLoading,
}) => {
  const icon = <TrashIcon className='h-4 w-4' />;

  const footer = (
    <>
      <Button color='danger' variant='light' onPress={onOpenChange} disabled={isLoading}>
        Cancel
      </Button>
      <Button color='danger' onPress={onSubmit} isLoading={isLoading}>
        Delete User
      </Button>
    </>
  );

  return (
    <ModernModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title='Delete User'
      subtitle='Remove user account'
      icon={icon}
      size='md'
      footer={footer}
    >
      <TypographyUI>
        Are you sure you want to delete user &quot;{selectedUser?.username}&quot;? This action cannot be undone.
      </TypographyUI>
    </ModernModal>
  );
};
